<template>
    <div  v-if="showcomponents">
        <topHead></topHead>
        <navLeft @setPage="changePage"></navLeft>
        <div class="box" style="">
            <transition name="move">
                <component :is="currentPage"></component>
            </transition>
        </div>
    </div>
</template>

<script>
    import topHead from '@/pages/topHead'
    import navLeft from '@/pages/navLeft'
    import application from '@/pages/application'
    import agent from '@/pages/agent'
    import index from '@/pages/index'
    import group from '@/pages/group'
    import shop from '@/pages/shop'
    import screen from '@/pages/screen'
    export default {
        data (){
            return{
                currentPage:'index',
                store:{},
                showcomponents:false,
            }
        },
        components:{
            topHead:topHead,
            navLeft:navLeft,
            application:application,
            agent:agent,
            index:index,
            group:group,
            shop:shop,
            screen:screen
        },
        created(){
            var that = this;

            //没有选择过登录方式
            var logintypeagent = that.accountutil.isLoginTypeAgent() ;
            var logintypegroup = that.accountutil.isLoginTypeGroup() ;
            if( !(logintypeagent||logintypegroup )){
                that.accountutil.setRedirectLogin();
                that.$emit('showDetail',false);
                //  that.$router.push('login');
                 return ;
            }

            that.accountutil.getAccountNow(that,function(res){

                  //代理商登录
                  if(logintypeagent){
                       that.accountutil.getAgentNow(that,function(){
                            that.showcomponents = true;
                            that.accountutil.clearRedirectLogin();
                        });
                       return; 
                  }  

                  
                  //集团登录
                  if(logintypegroup){

                      if(res.brandstore){
                          that.accountutil.setBrandStore(res.brandstore);
                          that.showcomponents = true;
                          that.accountutil.clearRedirectLogin();
                          return;
                      }

                      //可能换过管理员
                       that.accountutil.setRedirectLogin();
                       that.$emit('showDetail',false);
                    //   that.$router.push('login');
                      return ; 

                  }

            })
            
        },
        mounted(){
            var that = this;
            var boxHeight = document.querySelector('.box')
            var height = document.documentElement.clientHeight;
            // boxHeight.style.height = height + 'px';
            
        },
        methods:{
            changePage(val){
                var that = this;
                that.currentPage = val
            },
        },
        watch:{
            currentPage:{
                handler(val, oldVal){
                    console.log('new: %s, old: %s', val, oldVal)
                },
                deep:true
            }
        }
    }
</script>

<style scoped>
    .box{
        width: 100%;
        padding-top:50px;
        padding-left: 202px;
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }
    .slide-enter-active {
        transition: all .3s ease;
    }
    .slide-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-enter, .slide-leave-active {
        transform: translateX(10px);
        opacity: 0;
    }

    .move-enter-active, .food .move-leave-active {
        transition: all 0.5s linear;
        transform: translate3d(0, 0, 0);
    }
    .move-enter, .food .move-leave {
        transform: translate3d(100%, 0, 0);
    }
</style>


// WEBPACK FOOTER //
// src/pages/modelBox.vue